import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const reportService = {
  /** 分页查询当前部门的江西维保计划及报告状态。 */
  page: params => axios.get(`${iffApi}/jxxf/wb/report/plans`, { params }),
  /** 生成不落库、不占用正式编号的临时预览 PDF。 */
  preview: id => axios.post(`${iffApi}/jxxf/wb/report/plans/${id}/preview`),
  /** 生成并冻结正式未盖章报告。 */
  formal: id => axios.post(`${iffApi}/jxxf/wb/report/plans/${id}/formal`),
  /** 撤回未盖章报告，使计划恢复为可编辑状态。 */
  requestModification: (id, data) => axios.post(`${iffApi}/jxxf/wb/report/plans/${id}/request-modification`, data),
  /** 上传签字盖章后的最终报告。 */
  uploadSealedReport: (id, data) => axios.post(`${iffApi}/jxxf/wb/report/plans/${id}/sealed-report`, data)
};
